//seedData.js
// ---------- FOODS ----------
export const initialFoods = [
  {
    id: "f1",
    name: "Grilled Chicken Breast",
    image: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d",
    calories: 165,
    carbs: 0,
    sugar: 0,
    protein: 31,
    fat: 11,
    gram: 100,
    categorie: "Meat",
    isRecipe: false,
  },
  {
    id: "f2",
    name: "Brown Rice",
    image: "https://images.unsplash.com/photo-1586201375761-83865001e31b",
    calories: 216,
    carbs: 45,
    sugar: 1,
    protein: 5,
    fat: 5,
    gram: 100,
    categorie: "Rice",
    isRecipe: false,
  },
  {
    id: "f3",
    name: "Avocado",
    image: "https://images.unsplash.com/photo-1547516508-6fd1c1f3b2c8",
    calories: 240,
    carbs: 12,
    sugar: 1,
    protein: 3,
    fat: 63,
    gram: 100,
    categorie: "Vegetable",
    isRecipe: false,
  },
  {
    id: "f4",
    name: "Greek Yogurt",
    image: "https://images.unsplash.com/photo-1571212515416-fef01fc43637",
    calories: 100,
    carbs: 6,
    sugar: 4,
    protein: 17,
    fat: 29,
    gram: 100,
    categorie: "Milk",
    isRecipe: false,
  },
  {
    id: "f5",
    name: "Banana",
    image: "https://images.unsplash.com/photo-1574226516831-e1dff420e8f8",
    calories: 105,
    carbs: 27,
    sugar: 14,
    protein: 1,
    fat: 59,
    gram: 100,
    categorie: "Fruits",
    isRecipe: false,
  },
];

const sumTotals = (foods, ids) => {
  const selected = foods.filter(f => ids.includes(f.id));

  return selected.reduce(
    (totals, f) => ({
      calories: totals.calories + f.calories,
      carbs: totals.carbs + f.carbs,
      sugar: totals.sugar + f.sugar,
      protein: totals.protein + f.protein,
      fat: totals.fat + f.fat,
    }),
    { calories: 0, carbs: 0, sugar: 0, protein: 0, fat: 0 }
  );
};

const toPortions = (ids, grams = 100) =>
  Object.fromEntries(ids.map(id => [id, grams]));

export const initialMeals = [
  {
    id: "m1",
    name: "Protein Bowl",
    foodPortions: toPortions(["f1", "f2", "f3"]),
    ...sumTotals(initialFoods, ["f1", "f2", "f3"]),
    mealType:"lunch",
    isRecipe: true,
  },
  {
    id: "m2",
    name: "Breakfast Power",
    foodPortions: toPortions(["f4", "f5", "f2"]),
    ...sumTotals(initialFoods, ["f4", "f5", "f2"]),
    mealType:"dinner",
    isRecipe: true,
  },
  {
    id: "m3",
    name: "Light Snack Plate",
    foodPortions: toPortions(["f3", "f4", "f5"]),
    ...sumTotals(initialFoods, ["f3", "f4", "f5"]),
    mealType:"breakfast",
    isRecipe: true,
  },
];